import React, { useEffect, useState } from 'react'
import Header from '../header/header'
import { AddAllocationFund, AddFund, CheckAllocation, GetAddedFundList, UserEtf } from '../../api/portfolio';
import { useDispatch, useSelector } from 'react-redux';
import { setuserDetail, setUserDetail } from '../../redux/auth/auth';
import toast from 'react-hot-toast';

const numberToWords = (num) => {
    const a = [
        '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
        'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen',
        'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
    ];
    const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    const convert = (n) => {
        if (n < 20) return a[n];
        if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
        if (n < 1000) return a[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " and " + convert(n % 100) : "");
        if (n < 100000) return convert(Math.floor(n / 1000)) + " Thousand" + (n % 1000 ? " " + convert(n % 1000) : "");
        if (n < 10000000) return convert(Math.floor(n / 100000)) + " Lakh" + (n % 100000 ? " " + convert(n % 100000) : "");
        return convert(Math.floor(n / 10000000)) + " Crore" + (n % 10000000 ? " " + convert(n % 10000000) : "");
    };

    if (!num || isNaN(num)) return '';
    return convert(Number(num)) + " Only";
};

export default function ETF() {
    const userDetail = useSelector(state => state.auth.userDetail)
    const userId = useSelector(state => state.auth.userDetail.id);
    const dispatch = useDispatch();
    const [userPortfolio, setUserPortfolio] = useState(null);
    const [userEtfAmt, setUserEtfAmt] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [amounts, setAmounts] = useState({
        etfAllocation: "",
    });
    const [validationErrors, setValidationErrors] = useState({});

    const handleAmountChange = (key) => (e) => {
        const rawValue = e.target.value.replace(/[^0-9]/g, ""); // Only digits
        const formattedValue = new Intl.NumberFormat("en-IN").format(Number(rawValue));

        setAmounts((prev) => ({
            ...prev,
            [key]: formattedValue,
        }));

        setValidationErrors((prevErrors) => ({
            ...prevErrors,
            [key]: "",
        }));
    };

    const validation = () => {
        let errors = {};
        const etf = Number(amounts.etfAllocation.replace(/,/g, ''));
        if (!etf || etf === 0) {
            errors.etfAllocation = "Enter a valid amount";
        }

        setValidationErrors(errors);
        return Object.keys(errors).length === 0;
    };
    const handlePortfolio = async () => {
        if (!validation()) return;
        try {
            const etfPayload = {
                userId: userId,
                invPortId: 2,
                amt: Number(amounts.etfAllocation.replace(/,/g, '')),
            }

            const etfResponse = await AddFund(etfPayload);
            if (etfResponse?.status) {
                const checkAllocation = await CheckAllocation(etfResponse?.data?.id)
                if (checkAllocation?.status) {
                    let allocationPayload = {
                        userId: localStorage.getItem("uid"),
                        stocks: [],
                    };

                    checkAllocation?.data?.stocks?.map((item, idx) => {
                        allocationPayload.stocks.push({
                            invPortStockId: item.id,
                            entryPrice: item.cmp,
                            qty: item.qty
                        })
                    })
                    const allocatedFundResponse = await AddAllocationFund(allocationPayload, etfResponse?.data?.id);
                    if (allocatedFundResponse?.status) {
                        toast.success(etfResponse?.message);
                        dispatch(setUserDetail({ ...userDetail, etfAllocation: etfPayload.amt }))
                        window.location.reload();
                    }
                }
            }
        } catch (error) {
            toast.error(error?.response?.data?.message)
        }
    };
    useEffect(() => {
        const fetchData = async () => {
            const response = await UserEtf();
            const fundResponse = await GetAddedFundList();
            dispatch(setUserDetail({ ...userDetail, etfAllocation: fundResponse?.data?.meta?.etfFundAmount }))
            setUserEtfAmt(fundResponse.data);
            setUserPortfolio(response.data);
            setIsLoading(false);
        }
        fetchData();
    }, [])


    const openStocks =
        userPortfolio?.openStocks?.map((s) => ({
            id: s.coCode,
            symbol: s.scrip,
            qty: s.qty,
            invested: s.invested,
            currentVal: s.currentVal,
            recomPrice: s.avgPrice,
            ltp: s.cmp,
            todayPLVal: s.dayPnlAmt,
            todayPLPer: s.dayPnlPer,
            overallPLVal: s.currentPnlAmt,
            overallPLPer: s.currentPnlPer,
        })) || [];
    const closedStocks =
        userPortfolio?.closedStocks?.map((s) => ({
            id: s.coCode,
            symbol: s.scrip,
            qty: s.qty,
            invested: s.invested,
            currentVal: s.currentVal,
            recomPrice: s.avgPrice,
            ltp: s.cmp,
            todayPLVal: s.dayPnlAmt,
            todayPLPer: s.dayPnlPer,
            overallPLVal: s.currentPnlAmt,
            overallPLPer: s.currentPnlPer,
        })) || [];

    return (
        isLoading ? (
            <div class="d-flex justify-content-center align-items-center vh-100">
                <div class="text-center">
                    <div class="spinner-border text-primary mb-2" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <div class="fw-semibold">Loading, please wait...</div>
                </div>
            </div> // or your skeleton loader
        ) : (
            <div>
                <Header />
                <div className="py-3">
                    <div className="container">
                        {userEtfAmt?.meta?.etfFundAmount > 0 ?
                            <>
                                <div className="row g-3 justify-content-between">
                                    <div className="col-md-12">
                                        <div className="d-flex align-items-baseline">
                                            <h1 className="fs-4 fw-bold text-capitalize mb-0">
                                                🚀 ETFs
                                            </h1>
                                            {/* <small className=" ms-2 fw-semibold">
                                    <small> ({userPortfolio?.openStocks?.length} {userPortfolio?.openStocks?.length > 1 ? "ETFs" : "ETF"}) </small>
                                </small> */}
                                        </div>
                                    </div>
                                    <div className="col-lg-2 col-md-3 col-6 d-none">
                                        <div>
                                            <small className="text-muted">Investment Amount</small>
                                            <h5 className="mb-0">
                                                {userPortfolio?.totalAddedFundAmt?.toLocaleString(
                                                    "en-IN"
                                                )}
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="col-lg-2 col-md-3 col-6 d-none">
                                        <div>
                                            <small className="text-muted">Available Funds</small>
                                            <h5 className="mb-0">
                                                {(
                                                    userPortfolio?.wealthInvestmentAmt -
                                                    userPortfolio?.totalInvestedAmt
                                                )?.toLocaleString("en-IN")}
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="col-lg-2 col-md-3 col-6">
                                        <div>
                                            <small className="text-muted">Invested</small>
                                            <h5 className="mb-0">
                                                {userPortfolio?.invested?.toLocaleString("en-IN")}
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="col-lg-2 col-md-3 col-6">
                                        <div>
                                            <small className="text-muted">Current Value</small>
                                            <h5 className="mb-0">
                                                {userPortfolio?.currentVal?.toLocaleString("en-IN")}
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="col-lg-2 col-md-3 col-6">
                                        <div>
                                            <small className="text-muted">Current P&amp;L</small>
                                            <div className="d-flex align-items-baseline">
                                                <h5
                                                    className={
                                                        userPortfolio?.currentPnlAmt >= 0 ? "text-green" : "text-red"
                                                    }
                                                >
                                                    {userPortfolio?.currentPnlAmt >= 0 ? "" : "-"}
                                                    {/* {userPortfolio?.currentPnlAmt?.toFixed(2)} */}
                                                    {Math.abs(userPortfolio?.currentPnlAmt || 0).toLocaleString(
                                                        "en-IN",
                                                        {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2,
                                                        }
                                                    )}
                                                </h5>
                                                <small
                                                    className={`ms-2 ${userPortfolio?.currentPnlPer >= 0 ? "text-green" : "text-red"
                                                        }`}
                                                >
                                                    (
                                                    {/* {userPortfolio?.currentPnlPer >= 0 ? "" : "-"} */}
                                                    {userPortfolio?.currentPnlPer || 0}%)
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-2 col-md-3 col-6">
                                        <div>
                                            <small className="text-muted">Day's P&amp;L </small>
                                            <div className="d-flex align-items-baseline">
                                                <h5
                                                    className={
                                                        userPortfolio?.dayPnlAmt >= 0
                                                            ? "text-green"
                                                            : "text-red"
                                                    }
                                                >
                                                    {userPortfolio?.dayPnlAmt >= 0 ? "" : "-"}
                                                    {Math.abs(
                                                        userPortfolio?.dayPnlAmt || 0
                                                    ).toLocaleString("en-IN", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                    })}
                                                </h5>
                                                <small
                                                    className={`ms-2 ${userPortfolio?.dayPnlPer >= 0
                                                        ? "text-green"
                                                        : "text-red"
                                                        }`}
                                                >
                                                    ({userPortfolio?.dayPnlPer >= 0 ? "" : "-"}
                                                    {Math.abs(
                                                        userPortfolio?.dayPnlPer || 0
                                                    ).toLocaleString("en-IN")}%)
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-2 col-md-3 col-6">
                                        <div>
                                            <small className="text-muted">Booked P&amp;L </small>
                                            <div className="d-flex align-items-baseline">
                                                <h5
                                                    className={
                                                        userPortfolio?.bookedPnl >= 0
                                                            ? "text-green"
                                                            : "text-red"
                                                    }
                                                >
                                                    {userPortfolio?.bookedPnl >= 0 ? "" : "-"}
                                                    {Math.abs(
                                                        userPortfolio?.bookedPnl || 0
                                                    ).toLocaleString("en-IN", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                    })}
                                                </h5>
                                                <small
                                                    className={`ms-2 ${userPortfolio?.bookedPnlPer >= 0
                                                        ? "text-green"
                                                        : "text-red"
                                                        }`}
                                                >
                                                    ({userPortfolio?.bookedPnlPer >= 0 ? "" : "-"}
                                                    {Math.abs(
                                                        userPortfolio?.bookedPnlPer || 0
                                                    ).toLocaleString("en-IN")}%)
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-2 col-md-3 col-6">
                                        <div>
                                            <small className="text-muted">OverAll P&amp;L </small>
                                            <div className="d-flex align-items-baseline">
                                                <h5
                                                    className={
                                                        userPortfolio?.overallPnl >= 0
                                                            ? "text-green"
                                                            : "text-red"
                                                    }
                                                >
                                                    {userPortfolio?.overallPnl >= 0 ? "" : "-"}
                                                    {Math.abs(
                                                        userPortfolio?.overallPnl || 0
                                                    ).toLocaleString("en-IN", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                    })}
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex align-items-baseline mt-3">
                                    <h5 class="mb-1 fw-bold">Open Recommendations</h5>
                                    <small class="text-muted ms-2">
                                        ({openStocks.length} {openStocks.length > 1 ? "ETFs" : "ETF"})
                                    </small>
                                </div>
                                {openStocks?.length > 0 ?
                                    <div className="row mt-2 ">
                                        <div className="col-md-12">

                                            <div className="table-responsive mt-2 rounded-3 border">
                                                <table
                                                    className="table table-hover align-middle mb-0"
                                                    style={{
                                                        borderCollapse: "separate",
                                                        borderSpacing: 0,
                                                        "--bs-border-opacity": 0.3,
                                                        fontSize: "14px",
                                                    }}
                                                >
                                                    <thead
                                                        className=" position-sticky top-0"
                                                        style={{ zIndex: 1 }}
                                                    >
                                                        <tr>
                                                            <th className="text-start" style={{ minWidth: "110px" }}>
                                                                <small className=" text-muted fw-normal">Scrip</small>
                                                            </th>
                                                            <th className="text-end" style={{ minWidth: "50px" }}>
                                                                <small className=" text-muted fw-normal">Qty.</small>
                                                            </th>
                                                            <th className="text-end" style={{ minWidth: "90px" }}>
                                                                <small className=" text-muted fw-normal">
                                                                    Avg. cost
                                                                </small>
                                                            </th>
                                                            <th className="text-end" style={{ minWidth: "90px" }}>
                                                                <small className=" text-muted fw-normal">LTP</small>
                                                            </th>
                                                            <th className="text-end" style={{ minWidth: "110px" }}>
                                                                <small className=" text-muted fw-normal">
                                                                    Invested
                                                                </small>
                                                            </th>
                                                            <th className="text-end" style={{ minWidth: "110px" }}>
                                                                <small className=" text-muted fw-normal">
                                                                    Cur. val
                                                                </small>
                                                            </th>
                                                            <th className="text-end" style={{ minWidth: "150px" }}>
                                                                <small className=" text-muted fw-normal">
                                                                    Cur. P&amp;L
                                                                </small>
                                                            </th>
                                                            {/* <th className="text-end"><small className="text-muted text-muted fw-normal">Net chg.</small></th> */}
                                                            <th className="text-end" style={{ minWidth: "150px" }}>
                                                                <small className=" text-muted fw-normal">
                                                                    Day's P&L
                                                                </small>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {userPortfolio?.openStocks?.map((stock, idx) => (
                                                            <tr key={idx}>
                                                                <td className="py-3">
                                                                    <span className="mb-0 fw-bold">{stock.scrip}</span>
                                                                    <div className="text-muted">{stock.name}</div>
                                                                </td>
                                                                <td className="py-2 text-end">
                                                                    {stock.qty?.toLocaleString("en-IN")}
                                                                </td>
                                                                <td className="py-2 text-end">
                                                                    {stock.avgPrice?.toLocaleString("en-IN")}
                                                                </td>
                                                                <td className="py-2 text-end">
                                                                    {stock.cmp?.toLocaleString("en-IN")}
                                                                </td>
                                                                <td className="py-2 text-end">
                                                                    {stock.invested != null
                                                                        ? Number(stock.invested).toLocaleString(
                                                                            "en-IN",
                                                                            {
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2,
                                                                            }
                                                                        )
                                                                        : "--"}
                                                                </td>
                                                                <td className="py-2 text-end">
                                                                    {stock.currentVal != null
                                                                        ? Number(stock.currentVal).toLocaleString(
                                                                            "en-IN",
                                                                            {
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2,
                                                                            }
                                                                        )
                                                                        : "--"}
                                                                </td>
                                                                {/* <td className={`py-2 text-end text-${stock.netChange < 0 ? "danger" : "success"}`}>{stock.pnl?.toFixed(2)}<small className={`${stock?.netChange > 0 ? "text-green" : "text-red"} ms-1`}>({stock?.netChange?.toFixed(2)}%)</small></td> */}
                                                                <td
                                                                    className={`py-2 text-end text-${stock.currentPnlAmt < 0 ? "red" : "green"
                                                                        }`}
                                                                >
                                                                    {stock.currentPnlAmt != null
                                                                        ? Number(stock.currentPnlAmt).toLocaleString("en-IN", {
                                                                            minimumFractionDigits: 2,
                                                                            maximumFractionDigits: 2,
                                                                        })
                                                                        : "--"}
                                                                    <small
                                                                        className={`ms-1 text-${stock?.currentPnlPer >= 0 ? "green" : "red"
                                                                            }`}
                                                                    >
                                                                        (
                                                                        {stock.currentPnlPer != null
                                                                            ? Number(stock.currentPnlPer).toFixed(2)
                                                                            : "--"}
                                                                        %)
                                                                    </small>
                                                                </td>
                                                                <td
                                                                    className={`py-2 text-end text-${stock?.dayPnlAmt < 0
                                                                        ? "red"
                                                                        : "green"
                                                                        }`}
                                                                >
                                                                    {stock?.dayPnlAmt != null
                                                                        ? Number(stock?.dayPnlAmt).toLocaleString(
                                                                            "en-IN",
                                                                            {
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2,
                                                                            }
                                                                        )
                                                                        : "--"}
                                                                    <small
                                                                        className={`ms-1 text-${stock?.dayPnlPer < 0
                                                                            ? "red"
                                                                            : "green"
                                                                            }`}
                                                                    >
                                                                        (
                                                                        {stock?.dayPnlPer != null
                                                                            ? Number(stock?.dayPnlPer).toFixed(2)
                                                                            : "--"}
                                                                        %)
                                                                    </small>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div className="text-center text-muted py-4">
                                        All recommendations and the P&L summary are displayed here.
                                    </div>
                                }
                                <div class="d-flex align-items-baseline mt-3">
                                    <h5 class="mb-1 fw-bold">Closed Recommendations</h5>
                                    <small class="text-muted ms-2">
                                        ({closedStocks.length} {closedStocks.length > 1 ? "ETFs" : "ETF"})
                                    </small>
                                </div>
                                {closedStocks?.length > 0 ?
                                    <div className="row mt-2 ">
                                        <div className="col-md-12">
                                            <div className="table-responsive mt-2 rounded-3 border">
                                                <table
                                                    className="table table-hover align-middle mb-0"
                                                    style={{
                                                        borderCollapse: "separate",
                                                        borderSpacing: 0,
                                                        "--bs-border-opacity": 0.3,
                                                        fontSize: "14px",
                                                    }}
                                                >
                                                    <thead
                                                        className=" position-sticky top-0"
                                                        style={{ zIndex: 1 }}
                                                    >
                                                        <tr>
                                                            <th className="text-start" style={{ minWidth: "110px" }}>
                                                                <small className=" text-muted fw-normal">Scrip</small>
                                                            </th>
                                                            <th className="text-end" style={{ minWidth: "50px" }}>
                                                                <small className=" text-muted fw-normal">Qty.</small>
                                                            </th>
                                                            <th className="text-end" style={{ minWidth: "90px" }}>
                                                                <small className=" text-muted fw-normal">
                                                                    Avg. cost
                                                                </small>
                                                            </th>
                                                            <th className="text-end" style={{ minWidth: "90px" }}>
                                                                <small className=" text-muted fw-normal">LTP</small>
                                                            </th>
                                                            <th className="text-end" style={{ minWidth: "110px" }}>
                                                                <small className=" text-muted fw-normal">
                                                                    Invested
                                                                </small>
                                                            </th>
                                                            <th className="text-end" style={{ minWidth: "110px" }}>
                                                                <small className=" text-muted fw-normal">
                                                                    Cur. val
                                                                </small>
                                                            </th>
                                                            <th className="text-end" style={{ minWidth: "150px" }}>
                                                                <small className=" text-muted fw-normal">
                                                                    Cur. P&amp;L
                                                                </small>
                                                            </th>
                                                            {/* <th className="text-end"><small className="text-muted text-muted fw-normal">Net chg.</small></th> */}
                                                            <th className="text-end" style={{ minWidth: "150px" }}>
                                                                <small className=" text-muted fw-normal">
                                                                    Day's P&L
                                                                </small>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {closedStocks?.map((stock, idx) => (
                                                            <tr key={idx}>
                                                                <td className="py-3">
                                                                    <span className="mb-0 fw-bold">{stock.scrip}</span>
                                                                    <div className="text-muted">{stock.name}</div>
                                                                </td>
                                                                <td className="py-2 text-end">
                                                                    {stock.qty?.toLocaleString("en-IN")}
                                                                </td>
                                                                <td className="py-2 text-end">
                                                                    {stock.avgPrice?.toLocaleString("en-IN")}
                                                                </td>
                                                                <td className="py-2 text-end">
                                                                    {stock.cmp?.toLocaleString("en-IN")}
                                                                </td>
                                                                <td className="py-2 text-end">
                                                                    {stock.invested != null
                                                                        ? Number(stock.invested).toLocaleString(
                                                                            "en-IN",
                                                                            {
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2,
                                                                            }
                                                                        )
                                                                        : "--"}
                                                                </td>
                                                                <td className="py-2 text-end">
                                                                    {stock.currentVal != null
                                                                        ? Number(stock.currentVal).toLocaleString(
                                                                            "en-IN",
                                                                            {
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2,
                                                                            }
                                                                        )
                                                                        : "--"}
                                                                </td>
                                                                {/* <td className={`py-2 text-end text-${stock.netChange < 0 ? "danger" : "success"}`}>{stock.pnl?.toFixed(2)}<small className={`${stock?.netChange > 0 ? "text-green" : "text-red"} ms-1`}>({stock?.netChange?.toFixed(2)}%)</small></td> */}
                                                                <td
                                                                    className={`py-2 text-end text-${stock.currentPnlAmt < 0 ? "red" : "green"
                                                                        }`}
                                                                >
                                                                    {stock.currentPnlAmt != null
                                                                        ? Number(stock.currentPnlAmt).toLocaleString("en-IN", {
                                                                            minimumFractionDigits: 2,
                                                                            maximumFractionDigits: 2,
                                                                        })
                                                                        : "--"}
                                                                    <small
                                                                        className={`ms-1 text-${stock?.currentPnlPer >= 0 ? "green" : "red"
                                                                            }`}
                                                                    >
                                                                        (
                                                                        {stock.currentPnlPer != null
                                                                            ? Number(stock.currentPnlPer).toFixed(2)
                                                                            : "--"}
                                                                        %)
                                                                    </small>
                                                                </td>
                                                                <td
                                                                    className={`py-2 text-end text-${stock?.dayPnlAmt < 0
                                                                        ? "red"
                                                                        : "green"
                                                                        }`}
                                                                >
                                                                    {stock?.dayPnlAmt != null
                                                                        ? Number(stock?.dayPnlAmt).toLocaleString(
                                                                            "en-IN",
                                                                            {
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2,
                                                                            }
                                                                        )
                                                                        : "--"}
                                                                    <small
                                                                        className={`ms-1 text-${stock?.dayPnlPer < 0
                                                                            ? "red"
                                                                            : "green"
                                                                            }`}
                                                                    >
                                                                        (
                                                                        {stock?.dayPnlPer != null
                                                                            ? Number(stock?.dayPnlPer).toFixed(2)
                                                                            : "--"}
                                                                        %)
                                                                    </small>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div className="text-center text-muted py-4">
                                        All closed recommendations and the P&L summary are displayed here.
                                    </div>
                                }
                            </>
                            :
                            <div class="row g-3 mb-3">
                                <div class="col-md-12">
                                    <a href="/dashboard" class="text-decoration-none text-body-emphasis fs-5"><i class="fa fa-arrow-left"></i></a>
                                </div>
                                <div class="border rounded-3 p-3">
                                    <div class="row g-3 mb-3">
                                        <div class="col-md-12">
                                            <h1 class="fs-4 fw-bold ">ETF Setup</h1>
                                            {/* <p>Let's get started by setting up your ETF portfolio. Please enter your initial investment amount for ETFs.</p> */}
                                            <p>Please enter your initial investment amount for ETFs.</p>
                                            <div class="my-3">
                                                <div class="form-floating d-inline-block">
                                                    <input
                                                        type="text"
                                                        class="form-control fw-bold"
                                                        id="floatingInput"
                                                        placeholder="1005000"
                                                        style={{ "font-size": "1.5rem; letter-spacing: 1px" }}
                                                        value={amounts.etfAllocation}
                                                        onChange={handleAmountChange("etfAllocation")}
                                                    />
                                                    <label for="floatingInput">Enter Investment Amount</label>
                                                    {validationErrors.etfAllocation && (
                                                        <div className="text-danger mt-1">
                                                            {validationErrors.etfAllocation}
                                                        </div>
                                                    )}
                                                </div>
                                                <small class="d-block fst-italic text-muted mt-2">{numberToWords(amounts.etfAllocation.replace(/,/g, ''))}</small>
                                            </div>
                                            <button
                                                class="btn btn-md"
                                                style={{
                                                    // height: '45px', 
                                                    background: 'linear-gradient(to right, #C609FA, #3959FE, #0E9EEE)',
                                                    color: 'white', // or another readable solid color
                                                    // height: '45px',
                                                    border: 'none',
                                                }}
                                                onClick={() => handlePortfolio()}>
                                                Continue
                                            </button>
                                            <p class="text-muted mt-3 mb-0"><small><b>Note:</b> This is not an actual fund transfer. The amount is used only to create a personalized dashboard for you.</small></p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    )
}
